/**
* Calcluates load for selected property
* 
*/
app.directive('apartmentLoanCalculator', function() {
	return {
		restrict: 'EA',
		templateUrl: 'apartment-load-calculator.html',
		scope: {
			propertyId: '=',
			propertyPrice: '=',
			loanBatches: '=&',
			loanTime: '=&',
			ownSavings: '=&',
			monthlyDue: '=&',
			wholeEstimate: '=&'
		},
		controller: ["$scope", function($scope) {
			var self = this;
			var propertyPrice = self.propertyPrice,
				ownSavings = self.ownSavings,
				interestRate = getInterestRate().then(enableCalculator, interestLoadFailed);
			
			self.ownSavings = propertyPrice * 0.10;
			self.loanTime = 25;
			self.interestRate = 1.2;
			self.monthlyDue = 0;
			self.wholeEstimate = 0;
			self.loanBatches = 0;

			this.calculateLoanDetails = function() {
				var A = interestRate / 1200;
				var B = (1 + A)^loanBatches;
				var C = (1 + A)^(loanBatches - 1);
				var multiplier = (A * B) / C;

				this.monthlyDue = Math.round(multiplier * (propertyPrice - ownSavings));
				this.wholeEstimate = self.monthlyDue * loanBatches;
				self.loanBatches = loanTime * 12;
			};

			this.sendClatulation = function() {
				var params = {
					name: self.name,
					email: self.email,
					phone: self.phone,
					yearOfBirth: self.yearOfBirth,
					location: self.location,
					message: self.message,
					propertyAddress: self.propertyAddress,
					propertyType: self.propertyType,
					propertyPrice: propertyPrice,
					propertyId: self.propertyId,
					propertyDesc: self.propertyDesc,
					ownSavings: ownSavings,
					loanTime: loanTime,
					interestRate: interestRate,
					monthlyDue: self.monthlyDue,
					wholeEstimate: self.wholeEstimate
				};

				$http.post('', params, sendSuccessful, sendFailed);
			};

			function sendSuccessful(response) {

			}

			function sendFailed(error) {

			}

			function getInterestRate() {
				return $http.get('');
			}

			function enableCalculator(response) {

			}

			function interestLoadFailed(error) {

			}
		}],
		controllerAs: 'vm'
	};
});
	
